import { push } from 'connected-react-router'

import {
  beginInitialization,
  initializeViewType,
  addFirestoreUnlistener,
  completeListInfoLoad,
  completeTodoItemLoad,
  endTodoInitialization,
  clearAll,
  setTitleViaFirebase,
  setDescriptionViaFirebase,
  addTodoViaFirebase,
  modifyTodoViaFirebase,
  removeTodoViaFirebase
} from './actionCreators'

import { firestore, fsRootCollection, getNewTodoList } from '../firebase'

import { handleError } from '../utilities'

// mostly firestore-related thunks

/*
function loadLocalTodos(userId){
  return (dispatch) => {
    const localTodoStr = localStorage.getItem(`todos-redux-${userId}`);
    const localTodos = localTodoStr!==null
      ? {
        ...JSON.parse(localTodoStr),
        editIndex: -1,
        areInitialized: true,
      }
      : {
        todoItems: [],
        numTodosCreated: 0,
        editIndex: -1,
        areInitialized: true,
      };

    setTimeout( // simulate a delay
      () => { dispatch(loadTodos(localTodos)); },
      250 + Math.floor(250 * Math.random())
    );

    return Promise.resolve();
  };
}
*/

// TODO: implement non-trivial error checking
export function initializeTodoApp (listId) {
  return async (dispatch, getState) => {
    // get listId if undefined (i.e. we are at server root so no :listId match)
    if (listId === undefined) {
      listId = await getNewTodoList()
      dispatch(push(`/${listId}`))
    }

    dispatch(beginInitialization(listId))
    dispatch(initializeTypeAndListen(listId))
  }
}

/*
//TODO: actually handle thrown errors
export function exitTodoApp(){
  return (dispatch, getState) => {
    const { infoUnlistener, todoUnlistener } = getState().listInfo;

    infoUnlistener(); //impure stuff goes in thunks, right?
    todoUnlistener();

    // return firebaseAuth.signOut().then(
    //   () => {
    //     dispatch(push("/"));
    //     dispatch(clearAll());
    //     return Promise.resolve();
    //   },
    //   () => { return trivialError("firebase signout failed"); }
    // );

    dispatch(clearAll());
    dispatch(push("/"));
  }
}
*/

export function resetTodoApp (listId) {
  return (dispatch, getState) => {
    const { unlisteners } = getState().firestore

    // impure stuff goes in thunks, right?
    unlisteners.forEach(unlistener => {
      // maybe-unnecessary null/undefined check
      if (unlistener) {
        unlistener()
      }
    })

    dispatch(clearAll())
    dispatch(push(`/${listId}`))
    dispatch(initializeTodoApp(listId))
  }
}

function initializeTypeAndListen (listId) {
  return (dispatch, getState) => {
    firestore
      .doc(`${fsRootCollection}/${listId}`)
      .get()
      .then(
        doc => {
          const { type } = doc.data()
          // "FORK" and null are defunct, but it's nice to check
          if (type === 'TEMPLATE' || type === 'FORK' || type === null) {
            dispatch(initializeViewType('DEFAULT'))
          } else if (type === 'COPY') {
            dispatch(initializeViewType('STUDENT'))
          } else {
            throw new Error('INVALID TODO LIST TYPE FROM SERVER')
          }
          dispatch(listenForListInfoChanges(listId))
          dispatch(listenForTodoChanges(listId))
        },
        error => {
          handleError(error)
        }
      )
  }
}

function listenForListInfoChanges (listId) {
  return (dispatch, getState) => {
    const infoUnlistener = firestore
      .doc(`${fsRootCollection}/${listId}`)
      .onSnapshot(
        snapshot => {
          const { title, description } = snapshot.data()
          if (title !== undefined) {
            dispatch(setTitleViaFirebase(title))
          }
          if (description !== undefined) {
            dispatch(setDescriptionViaFirebase(description))
          }

          const { listInfoIsLoaded, todoItemsAreLoaded } = getState().firestore

          if (!listInfoIsLoaded) {
            dispatch(completeListInfoLoad())
            if (todoItemsAreLoaded) {
              dispatch(endTodoInitialization())
            }
          }
        },
        error => {
          handleError(error)
        }
      )

    dispatch(addFirestoreUnlistener(infoUnlistener))
  }
}

function listenForTodoChanges (listId) {
  return (dispatch, getState) => {
    const todoUnlistener = firestore
      .collection(`${fsRootCollection}/${listId}/todos`)
      .orderBy('time' /* , "asc" */) // just being safe here
      .onSnapshot(
        snapshot => {
          snapshot.docChanges().forEach(change => {
            const { type, doc } = change
            const changedDoc = {
              ...doc.data(),
              id: doc.id
            }

            switch (type) {
              case 'added':
                dispatch(addTodoViaFirebase(changedDoc))
                break
              case 'modified':
                dispatch(modifyTodoViaFirebase(changedDoc))
                break
              case 'removed':
                dispatch(removeTodoViaFirebase(changedDoc))
                break
              default:
                break
            }
          })

          const { listInfoIsLoaded, todoItemsAreLoaded } = getState().firestore

          if (!todoItemsAreLoaded) {
            dispatch(completeTodoItemLoad())
            if (listInfoIsLoaded) {
              dispatch(endTodoInitialization())
            }
          }
        },
        error => {
          handleError(error)
        }
      )

    dispatch(addFirestoreUnlistener(todoUnlistener))
  }
}



// WEBPACK FOOTER //
// ./src/actions/thunks.js